export default __webpack_public_path__ + "static/media/bg.3dbd1203.svg";